// extracted by mini-css-extract-plugin
module.exports = {"colorPrimary":"#ff7171","root":"Error_root__2eCCK","container":"Error_container__2qOmM","heading":"Error_heading__hlpBe","link":"Error_link__5Q7-B"};